module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('instamapsBreadcrumbs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasBreadcrumbs),
      expression: "hasBreadcrumbs"
    }],
    attrs: {
      "title": _vm.$t('title')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "my-form-signin",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('section', [_c('h3', {
    staticClass: "form-signin-heading"
  }, [_vm._v(_vm._s(_vm.$t('iniciaSessio')))]), _vm._v(" "), _c('fieldset', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user),
      expression: "user"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "user",
      "id": "user",
      "data-vv-validate-on": "blur",
      "placeholder": _vm.$t('userPlaceholder')
    },
    domProps: {
      "value": (_vm.user)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('user')),
      expression: "errors.has('user')"
    }],
    staticClass: "centered validationErrorMsg"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('formValidation')))])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "data-vv-validate-on": "blur",
      "placeholder": _vm.$t('passwordPlaceholder')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password')),
      expression: "errors.has('password')"
    }],
    staticClass: "centered validationErrorMsg"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('formValidation')))])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg bt-sessio btn-block",
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('iniciaSessio')))]), _vm._v(" "), _c('div', {
    staticClass: "social-sign"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('oAmb')))]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "zocial icon facebook",
    attrs: {
      "href": _vm.socialAuth + 'id=facebook',
      "id": "signin_facebook",
      "title": "Inicia sessió amb Facebook"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "zocial icon googleplus",
    attrs: {
      "href": _vm.socialAuth + 'id=googleplus',
      "id": "signin_google",
      "title": "Inicia sessió amb  Google+"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "zocial icon twitter",
    attrs: {
      "href": _vm.socialAuth + 'id=twitter',
      "id": "signin_twitter",
      "title": "Inicia sessió amb Twitter"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "zocial  icon linkedin",
    attrs: {
      "href": _vm.socialAuth + 'id=linkedin',
      "id": "signin_linkedin",
      "title": "Inicia sessió amb LinkedIn"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "zocial icon eacat_fd",
    attrs: {
      "href": _vm.eacat,
      "id": "signin_eacat",
      "title": "Inicia sessió amb EACAT"
    }
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "social-sign sm-top"
  }, [_c('h6', {
    attrs: {
      "lang": "ca"
    }
  }, [_vm._v(_vm._s(_vm.$t('primeraVegada')))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "registre"
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('crearCompte')))])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "oblidat"
    }
  }, [_c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "id": "btn_remember_pssw",
      "lang": "ca",
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('rememberPsswd')))])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "disclaimer",
    attrs: {
      "lang": "ca"
    }
  }, [_vm._v(_vm._s(_vm.$t('disclaimerMsg')))]), _vm._v(" "), _c('p', {
    staticClass: "disclaimer",
    attrs: {
      "lang": "ca"
    }
  }, [_vm._v(_vm._s(_vm.$t('disclaimerMsg2')))]), _vm._v(" "), _c('p', {
    staticClass: "disclaimer",
    attrs: {
      "lang": "ca"
    }
  }, [_vm._v(_vm._s(_vm.$t('disclaimerMsg3')))]), _vm._v(" "), _c('p', {
    staticClass: "disclaimer",
    attrs: {
      "lang": "ca"
    }
  }, [_vm._v(_vm._s(_vm.$t('disclaimerMsg4')))])], 1)])]), _vm._v(" "), _c('instamapsMessageModal', {
    attrs: {
      "delay": 10,
      "isError": _vm.modalIsError,
      "isLoaded": _vm.modalIsLoaded,
      "title": _vm.modalTitle,
      "message": _vm.modalMessage
    },
    on: {
      "loaded": _vm.loaded
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2780f0f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/login/login.vue
// module id = 293
// module chunks = 0